import Controller from '@ember/controller';
import { DateTime } from 'scaleflow/utils/date-time';
import organisationValidations from '../../validators/organisation';
import { action } from '@ember/object';

export default class SettingsOrganisationDetailsController extends Controller {
  organisationValidations = organisationValidations;

  get organisation() {
    return this.model;
  }

  get dayOptions() {
    return Array.apply(null, Array(7)).map(function (_, i) {
      return {
        label: DateTime.isoWeekdayName(i + 1),
        value: i + 1,
      };
    });
  }

  @action
  handleOptionSelect(changeset, e) {
    changeset.set('first_day_of_week', e.value);
  }
}
